import {FC} from "react";
import {Card, CardProps, useTheme} from "@mui/material";

export const StyledCard: FC<CardProps> = ({children,sx, ...rest}) => {
    const theme = useTheme()
    return (
        <Card
            component='div'
            elevation={0}
            sx={{
                p: 3,
                borderRadius: "8px",
                border: `1px solid ${theme.palette.grey[200]}`,
                ...sx
            }}
            {...rest}
        >
            {children ?? <></>}
        </Card>
    )
}